import { Routes } from '@angular/router';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { PericiasComponent } from './pages/pericias/pericias.component';
import { ModulosAnaliticosComponent } from './pages/modulos-analiticos/modulos-analiticos.component';
import { RelatoriosComponent } from './pages/relatorios/relatorios.component';
import { AdministracaoComponent } from './pages/administracao/administracao.component';
import { CalendarioComponent } from './pages/calendario/calendario.component';
import { PendenciasComponent } from './pages/pendencias/pendencias.component';
import { HelpVersaoComponent } from './pages/help-versao/help-versao.component';
import { HelpDocumentosComponent } from './pages/help-documentos/help-documentos.component';

export const routes: Routes = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  { path: 'dashboard', component: DashboardComponent },
  { path: 'pericias', component: PericiasComponent },
  { path: 'modulos-analiticos', component: ModulosAnaliticosComponent },
  { path: 'relatorios', component: RelatoriosComponent },
  { path: 'calendario', component: CalendarioComponent },
  { path: 'pendencias', component: PendenciasComponent },
  { path: 'administracao', component: AdministracaoComponent },
  { path: 'help/versao', component: HelpVersaoComponent },
  { path: 'help/documentos', component: HelpDocumentosComponent },
  { path: '**', redirectTo: 'dashboard' }
];
